import { styled } from 'styled-components';
import { CardContent as MuiCardContent } from '@mui/material';

export const CardContent = styled(MuiCardContent)`
    flex: 1 1 auto;
    padding: ${({ theme }) => theme.spacing(3)};
`;
